import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  networkErr: false
};

const networkSlice = createSlice({
  name: 'network',
  initialState,
  reducers: {
    setNetwrokTrue: (state) => {
      state.networkErr = true;

    },
    setNetwrokFalse: (state) => {
        state.networkErr = false;
      },
   
  }
});

export const { setNetwrokTrue, setNetwrokFalse } = networkSlice.actions; 
export default networkSlice.reducer;